module.exports = __webpack_public_path__ + "img/Card_heart_Q.e52e69d8.svg";